import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import RegisterManagedForm from "./Form";
import { AppContext, TOAST } from "../../context";

const useStyles = makeStyles((theme) => ({
  registerManaged: {},
  pageInfo: {
    fontSize: "0.875rem",
    color: theme.app.secondaryColor,
    marginBottom: "16px",
    marginTop: ".5rem",
  },
}));

const REGISTER_MANAGED_PARTY = gql`
  mutation registerManagedParty($payload: RegisterManagedPartyMutation!) {
    registerManagedParty(payload: $payload) {
      isSuccess
      message
    }
  }
`;

const RegisterManaged = () => {
  const classes = useStyles();
  const { dispatch } = useContext(AppContext);
  const language = useSelector((state) => state.language);
  const handleMutationError = (error) => {
    dispatch({ type: TOAST, payload: { text: error, variant: "error" } });
  };
  const handleMutationSuccess = ({ registerManagedParty }) => {
    if (registerManagedParty.isSuccess) {
      return dispatch({
        type: TOAST,
        payload: {
          text: language.Toasts.registerManagedPartySuccess,
          variant: "success",
        },
      });
    }
    return dispatch({
      type: TOAST,
      payload: {
        text:
          language.Toasts[registerManagedParty.message] ||
          registerManagedParty.message,
        variant: "error",
      },
    });
  };
  const [register] = useMutation(REGISTER_MANAGED_PARTY, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess,
  });
  const handleSubmit = (values, actions) =>
    register({ variables: { payload: values } }).then(() =>
      actions.resetForm()
    );
  return (
    <div className={classes.registerManaged}>
      <Typography variant="h1">{language.Pages["register managed"]}</Typography>
      <Typography className={classes.pageInfo}>
        {language.PageInfo["register managed"]}
      </Typography>
      <RegisterManagedForm
        handleSubmit={(values, actions) => handleSubmit(values, actions)}
        language={language}
      />
    </div>
  );
};

export default RegisterManaged;
